// Content for Śrīmad-Bhāgavatam 1.2.10 commentary topic

import type { TopicContent } from '../types';

const content: TopicContent = {
    primarySloka: {
        reference: 'Srimad Bhagavatam 1.2.10',
        sloka: `kāmasya nendriya-prītir
lābho jīveta yāvatā |
jīvasya tattva-jijñāsā
nārtho yaś ceha karmabhiḥ ||`,
        translation:
            'For one who desires apavarga (<strong>kāmasya ... yāvatā</strong>), sense pleasure attained from enjoying sense objects is not the goal (<strong>nendriya-prītir lābhaḥ</strong>) as long as one lives (<strong>jīveta yāvatā</strong>). The goal of life is inquiry into the highest truth (<strong>jīvasya tattva-jijñāsā</strong>). What is accomplished by prescribed duties is not the goal (<strong>nārtho yaś ceha karmabhiḥ</strong>).',
    },
    blocks: [
        {
            type: 'text',
            content:
                'The pleasure of the senses (indriya-pritiḥ) arising from enjoying senses objects is not the goal (lābhaḥ). Rather, <strong>as long as one lives (yāvatā jiveta) one should work for the fulfillment of life (apavarga).</strong>',
        },
        {
            type: 'text',
            content:
                '<strong>Since jñāna and yoga are transformations of niṣkāma-karma, they perceive whatever happiness and distress they experience as results of karma.<br /><br />For the devotees, the pleasure of the senses from sense objects which accompany bhakti however are not called fruits of action (karma) since bhakti is not a transformation of karma. The devotees, however, perceive happiness to be the result of bhakti only. They regard suffering as the mercy of the Lord:</strong>',
        },
        {
            type: 'sloka',
            sloka: {
                reference: 'Srimad Bhagavatam 10.88.8',
                sloka: `yasyāham anugṛhṇāmi
hariṣye tad-dhanaṁ śanaiḥ |
tato ’dhanaṁ tyajanty asya
svajanā duḥkha-duḥkhitam ||`,
                translation:
                    'If I especially favor someone, I gradually deprive him of his wealth. Then the relatives and friends of such a poverty-stricken man abandon him. In this way he suffers one distress after another.',
            },
        },
        {
            type: 'text',
            content:
                '<strong>Taking this statement of the Lord into consideration, according to the particular case, the devotee’s suffering should be regarded as direct action of the Lord or a result of devotional offenses.</strong>',
        },
        {
            type: 'text',
            content:
                '<strong>The goal of life (jīvasya) is inquiry into the highest truth (tattva-jijñāsā).</strong><br /><br />What is accomlished (iha) by performance of karmas, such as attaining Svarga, is not the goal.',
        },
    ],
};

export default content;
